<template>
    <Form @submit="createOrUpdate" :key="createMode">
        <div class="book-type-form flex flex-column overflow-hidden gap-3">
            <CustomInputText name="code" :label="$t('message.studbookType.code')" required
                             v-model="editedBook.code" class="w-10" noPlaceholder
                             :customErrorMessage="getRequiredMessage(editedBook.code)"/>
            <CustomInputText name="authority" :label="$t('message.studbookType.authority')" required
                             v-model="editedBook.authority" class="w-10 min-width-label" noPlaceholder
                             :customErrorMessage="getRequiredMessage(editedBook.authority)"/>
            <CustomSelectOne name="country" :label="$t('message.studbookType.country')" noPlaceholder
                             class="w-10" required :items="countries" itemLabel="name"
                             itemValue="id" v-model="editedBook.countryId"
                             :customErrorMessage="getRequiredMessage(editedBook.countryId)" />
            <CustomSelectOne v-if="horseBreed === 'ARABIAN'" name="countryCode" :label="$t('message.studbookType.countryCode')"
                             disabled noPlaceholder class="w-10" :items="countries" itemLabel="alpha2" itemValue="id"
                             v-model="editedBook.countryId" />
            <CustomSelectOne v-else name="countryCode" :label="$t('message.studbookType.countryCode')"
                             disabled noPlaceholder class="w-10" :items="countries" itemLabel="alpha3" itemValue="id"
                             v-model="editedBook.countryId" />
            <div class="book-type-buttons flex align-self-center gap-4 mt-6">
                <CustomButton :label="$t('message.other.save')" type="submit" />
                <CustomButton v-if="createMode" :label="$t('message.other.cancel')" secondary
                              @click="hideForm" />
                <CustomButton v-else :label="$t('message.other.delete')" secondary @click="deleteEvent"
                              :disabled="createMode" />
            </div>
        </div>
    </Form>
    <div class="isbc-logo flex justify-content-center mt-8 overflow-hidden">
        <img src="../../../../assets/ISBClogo.png" alt="isbc-logo" class="isbc-logo-image" />
    </div>
</template>

<script>
    import {Form} from "vee-validate";
    import _ from 'lodash';
    import { addBookType, updateBookType, deleteBookType } from "@/swagger/vue-api-client";
    import CustomInputText from "@/components/form/CustomInputText.vue";
    import CustomSelectOneHorseBreed from "@/components/form/CustomSelectOneHorseBreed.vue";
    import CustomCheckbox from "@/components/form/CustomCheckbox.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import { ValidateUtils } from "@/utils/ValidateUtils";
    import CustomSelectOne from "@/components/form/inner/CustomSelectOne.vue";

    export default {
        name: "BookTypeForm",
        components: {
            CustomCheckbox,
            CustomSelectOneHorseBreed,
            CustomInputText,
            CustomButton,
            CustomSelectOne,
            Form,
        },

            props: {
                selectedBook: {
                    type: Object,
                    required: true,
                },
                countries: {
                    type: Array,
                    default: () => [],
                },
                horseBreed: null,
            },

        data() {
            return {
                editedBook: {
                    code: "",
                    authority: "",
                    countryId: null,
                },
                createMode: true,
                showErrorMessages: false,
            };
        },

        emits: ["change-element", "createMode", "hideForm"],

        mounted() {
            this.$emit("createMode", this.createMode);
        },

        methods: {
            validateData() {
                let isCorrect = ValidateUtils.validateNotEmpty(this.editedBook, ["code", "authority", "countryId"]);
                this.showErrorMessages = !isCorrect;
                return isCorrect;
            },
            getRequiredMessage(value) {
                if (this.showErrorMessages && (value === null || value === "")) {
                    return this.$t("message.validations.required");
                }
                return "";
            },
            notifyChange() {
                this.$emit("change-element");
                this.$toast.add({
                    severity: "success",
                    summary: this.$t('message.other.success'),
                    detail: this.$t('message.other.dataSaved'),
                    life: 3000,
                });
            },
            notifyDelete() {
                this.$emit("change-element");
                this.$toast.add({
                    severity: "success",
                    summary: this.$t('message.other.success'),
                    detail: this.$t('message.other.elementDeleted'),
                    life: 3000,
                });
            },
            notifyError(error) {
                const message = error.response?.data?.message || this.$t('unknownError');
                this.$toast.add({
                    severity: "error",
                    summary: this.$t('message.other.error'),
                    detail: message,
                    life: 5000,
                });
            },
            async createOrUpdate() {
                if (this.validateData()) {
                    try {
                        if (this.createMode) {
                            await addBookType({ body: this.editedBook });
                        } else {
                            await updateBookType({ id: this.editedBook.id, body: this.editedBook });
                        }
                        this.notifyChange();
                    } catch (error) {
                        this.notifyError(error);
                    }
                }
            },
            async deleteEvent() {
                try {
                    await deleteBookType({ id: this.editedBook.id });
                    this.notifyDelete();
                    this.showErrorMessages = false;
                } catch (error) {
                    this.notifyError(error);
                }
            },
            hideForm() {
                this.$emit("hideForm");
            },
        },

        watch: {
            selectedBook(newValue) {
                this.editedBook = _.cloneDeep(newValue);
                this.createMode = newValue.id === null || newValue.id === undefined || isNaN(newValue.id);
                this.$emit("createMode", this.createMode);
            },
        },
    };
</script>

<style lang="scss">
    .book-type-form {
        .custom-input-text, .custom-select-one {
            padding-left: 170px;
            .custom-label {
                z-index: 999;
                position: absolute;
                transform: translateX(-100%);
                left: 160px;
                text-align: right;
            }
            &.min-width-label {
                .custom-label {
                    width: min-content;
                }
            }
        }
        @media screen and (max-width: 650px) {
            align-items: end;
            .custom-input-text, .custom-select-one {
                padding-left: 100px;
                .custom-label {
                    left: 95px;
                }
            }
        }
    }
    .isbc-logo {
        &-image {
            width: 208px;
            height: 120px;
        }
    }
</style>
